import { cn } from '@avanta/shared/utils/cn';

export const PREDEFINED_PHRASES_DIALOG_CLASSNAME =
  'flex h-140 max-h-[calc(100dvh-32px)] flex-col gap-0 overflow-hidden border-0 p-0 sm:max-w-6xl';

export const phraseItemClassName = cn(
  'relative flex w-full min-w-0 items-center justify-between gap-1 py-2 pr-1 pl-2 text-left text-sm leading-6',
  "before:absolute before:inset-y-0 before:left-0 before:w-0.5 before:bg-plum-300 before:transition-[width,background-color] before:content-['']",
  'group-hover:rounded-r-lg group-hover:bg-plum-100',
  'group-hover:before:w-1 group-hover:before:bg-plum-500'
);

export const categoryChipClassName = (isActive: boolean): string =>
  cn(
    'inline-flex h-5 shrink-0 items-center justify-center rounded-xl px-2 text-xs leading-none text-white transition-colors',
    isActive ? 'bg-plum-500' : 'bg-plum-300'
  );

export const SEARCH_INPUT_CLASSNAME =
  'h-10 w-full rounded-lg border border-plum-200 bg-gray-100 py-2 pr-3 pl-8 text-sm leading-4 text-denim-800 outline-none placeholder:text-gray-400';
